import { Box, Typography } from "@mui/material";
import { headerCont } from "../sxprops";

export const Header: React.FC = () => {
  return (
    <Box sx={headerCont}>
      <Typography variant="h4" color="primary.main">
        Notification Center
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="start">
        Efficiently manage all your notifications in one streamlined view
      </Typography>
    </Box>
  );
};
